module.exports = __webpack_public_path__ + "static/media/window.72bd429e.jfif";